<template>
  <base-dialog v-model="visible">
    <div :class="$style.container">
      <div :class="$style.overlay">
        <div v-if="$slots.hasOwnProperty('title')" :class="$style.title">
          <slot name="title" />
        </div>
        <div
          v-scrollbar="{ id: `scrollbar-${scrollbarId}` }"
          :class="$style.content"
        >
          <scrollbar-vertical
            :id="`scrollbar-${scrollbarId}`"
            :class="$style.scrollbar"
          />
          <slot name="content" />
        </div>
      </div>
    </div>
  </base-dialog>
</template>

<script>
import { generateRandomString } from 'lib/utils/string';

import BaseDialog from 'molecules/base/Dialog';
import { ScrollbarDirective, ScrollbarVertical } from 'molecules/scrollbar';

export default {
  name: 'DialogTemplate',
  components: {
    BaseDialog,
    ScrollbarVertical,
  },
  directives: {
    'scrollbar': ScrollbarDirective,
  },
  props: {
    value: Boolean,
  },
  data() {
    return {
      visible: false,
      scrollbarId: generateRandomString(),
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.visible = val;
      },
    },
    visible: {
      immediate: true,
      handler(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style lang="sass" module>
  .container
    width: 100%
    max-height: 80vh
    position: relative
    align-self: flex-end
    display: flex
    z-index: 1000

    +responsive('medium')
      max-width: 480px
      align-self: center

  .overlay
    width: 100%
    display: flex
    flex-direction: column
    padding: 10px 0
    background-color: #181823

    +responsive('medium')
      border-radius: 8px

    +responsive('large')
      padding: 15px 0

  .title
    margin-bottom: 10px
    padding: 10px 20px 0

    +responsive('large')
      padding: 15px 30px 0

      & + .content
        padding: 10px 30px 15px

  .content
    position: relative
    padding: 10px 20px
    overflow: auto

    +responsive('large')
      padding: 15px 30px

  .scrollbar
    height: 100%
    position: absolute
    top: 0
    right: 5px
</style>
